import { Chip } from '@mui/material';

const BACKGROUND_COLORS = {
  draft: 'lightgrey',
  review: 'grey',
  confirmed: '#00800160',
  paid: 'green',
  cancelled: 'red',
};

const FONT_COLORS = {
  draft: 'black',
  review: 'black',
  confirmed: 'white',
  paid: 'white',
  cancelled: 'white',
};

export default function OrderStatusChip({ order }) {

  return (
    <Chip
      label={order.status.toUpperCase()}
      size='small'
      style={{
        backgroundColor: BACKGROUND_COLORS[order.status],
        color: FONT_COLORS[order.status],
        fontSize: '10px',
        fontWeight: 'bold',
      }}
    />
  );
}